import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getStickers: {
    method: 'GET',
    url: `${configs.baseUrl}/api/stickers`,
  },
  getStickerDetail: {
    method: 'GET',
    url: `${configs.baseUrl}/api/stickers/{stickerId}`,
  },
  updateSticker: {
    method: 'PUT',
    url: `${configs.baseUrl}/api/stickers/{stickerId}`,
  },
  deleteSticker: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/stickers/{stickerId}`,
  },
  createSticker: {
    method: 'POST',
    url: `${configs.baseUrl}/api/stickers`,
  },
  uploadStickerImage: {
      method: 'POST',
      url: `${configs.baseUrl}/api/upload/public-upload/stickers`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
  }
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getStickers = async (params) => {
  const res = await resource.getStickers(params)
  return res.body
}

const getStickerDetail = async (stickerId, params) => {
  const res = await resource.getStickerDetail({stickerId}, params)
  
  return res.body
}

const updateSticker = async (stickerId, params) => {
  const res = await resource.updateSticker({stickerId}, params)
  
  return res.body
}

const deleteSticker = async (stickerId) => {
  const res = await resource.deleteSticker({stickerId})
  
  return res.body
}

const createSticker = async (body) => {
  const res = await resource.createSticker(body)
  
  return res.body
}

const uploadStickerImage = async (body) => {
  const res = await resource.uploadStickerImage(body)
  
  return res.body.key
}

export default {
  initResource,
  getStickers,
  getStickerDetail,
  updateSticker,
  uploadStickerImage,
  createSticker,
  deleteSticker
}
